import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export const ConsoleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 288 288">
    <svg
      id="SvgjsSvg1001"
      width="288"
      height="288"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
    >
      <defs id="SvgjsDefs1002"></defs>
      <g
        id="SvgjsG1008"
        transform="matrix(0.9167,0,0,0.9167,11.99514188091473,11.994864758682269)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          width="288"
          height="288"
        >
          <path
            fillRule="evenodd"
            d="M19.444 9.361c-.882-4.926-2.854-6.379-3.903-6.379-1.637 0-2.057 1.217-5.541 1.258-3.484-.041-3.904-1.258-5.541-1.258-1.049 0-3.022 1.453-3.904 6.379-.503 2.812-1.049 7.01.252 7.514 1.619.627 2.168-.941 3.946-2.266C6.558 13.266 7.424 12.95 10 12.95s3.442.316 5.247 1.659c1.778 1.324 2.327 2.893 3.946 2.266 1.301-.504.755-4.701.251-7.514zM6 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a1 1 0 1 1 0-2 1 1 0 1 1 0 2zm2-2a1 1 0 1 1 0-2 1 1 0 1 1 0 2z"
            clipRule="evenodd"
          ></path>
        </svg>
      </g>
    </svg>
  </SvgIcon>
);
